<div class="layout-row full-height" [ngbTooltip]="tooltip" openDelay="300" container="body" triggers="hover">
  <bringoz-icon iconName="package-outline" [fill]="iconFill"></bringoz-icon>
  <span class="md-tiny">{{packagesCount || ''}}</span>

  <ng-template #tooltip>
    <app-service-packages-info [packageList]="packageList"
                               [isPacked]="isPacked"
                               [hasMissingPackages]="hasMissingPackages"
                               [packingInfo]="packingInfo"
                               [packedDate]="packedDate">
    </app-service-packages-info>
  </ng-template>

</div>

